export default {

  computed: {
    subjects () {
      return [
        { value: 'ENG', text: 'Engelsk (ENG)' },
        { value: 'FRA', text: 'Fransk (Fra)' },
        { value: 'FSP', text: 'Fremmedsprål (FSP)' },
        { value: 'FYS', text: 'Fysikk (FYS)' },
        { value: 'GEO', text: 'Geografi (GEO)' },
        { value: 'GFG', text: 'Geofag (GFG)' },
        { value: 'HEL', text: 'Helse (HEL)' },
        { value: 'HIS', text: 'Historie (HIS)' },
        { value: 'INF', text: 'Informasjonsteknologi (INF)' },
        { value: 'KHV', text: 'Kunst og håndverk (KHV)' },
        { value: 'KJE', text: 'Kjemi (KJE)' },
        { value: 'KRL', text: 'Kristendom, religion, livssyn og etikk (KRLE)' },
        { value: 'KRO', text: 'Kroppsøving (KRO)' },
        { value: 'MAT', text: 'Matematikk (MAT)' },
        { value: 'MED', text: 'Mediefag (MED)' },
        { value: 'MHE', text: 'Mat og helse (MHE)' },
        { value: 'MUS', text: 'Musikk (MUS)' },
        { value: 'NAT', text: 'Naturfag (NAT)' },
        { value: 'NOR', text: 'Norsk (NOR)' },
        { value: 'POL', text: 'Politikk (POL)' },
        { value: 'POM', text: 'Politikk og menneskerettigheter (POM)' },
        { value: 'PSY', text: 'Psykologi (PSY)' },
        { value: 'REL', text: 'Religion (REL)' },
        { value: 'SAF', text: 'Samfunnsfag (SAF)' },
        { value: 'SAK', text: 'Samfunnskunnskap (SAK)' },
        { value: 'SAG', text: 'Samfunnsgeografi (SAG)' },
        { value: 'SOK', text: 'Sosialkunnskap (SOK)' },
        { value: 'SOS', text: 'Sosiologi og sosialantropologi (SOS)' },
        { value: 'SPA', text: 'Spansk (SPA)' },
        { value: 'TVE', text: 'Tverrfaglig (TVE)' },
        { value: 'TYS', text: 'Tysk (TYS)' },
        { value: 'TST', text: 'Test (TST)' },
      ]
    },
    programs () {
      return [
        { value: 'SU', text: 'Studieforberedende' },
        { value: 'YU', text: 'Yrkesfaglig' }
      ]
    },
    grades () {
      return [
        { value: 'aarstrinn1', text: '1. trinn' },
        { value: 'aarstrinn2', text: '2. trinn' },
        { value: 'aarstrinn3', text: '3. trinn' },
        { value: 'aarstrinn4', text: '4. trinn' },
        { value: 'aarstrinn5', text: '5. trinn' },
        { value: 'aarstrinn6', text: '6. trinn' },
        { value: 'aarstrinn7', text: '7. trinn' },
        { value: 'aarstrinn8', text: '8. trinn' },
        { value: 'aarstrinn9', text: '9. trinn' },
        { value: 'aarstrinn10', text: '10.trinn' },
        { value: 'vg1', text: 'Vg1' },
        { value: 'vg2', text: 'Vg2' },
        { value: 'vg3', text: 'Vg3' },
        { value: 'vok', text: 'Voksenopplæring' },
        { value: 'a1/a2', text: 'Voksen A1/A2' },
        { value: 'b1', text: 'Voksen B1' },
        { value: 'b2', text: 'Voksen B2' },
        { value: 'prep', text: 'Forkurs' },
        { value: 'forkurs', text: 'Forkurs' },
      ]
    }
  },
  methods: {
    translateGrades (feideGrade) {
      let translatedGrade = this.grades.find(grade => grade.value === feideGrade)
      return translatedGrade.text
    }
  }
}